import { useState } from 'react';
import { FormInstance } from 'antd';

export const useFormValidationHelper = (form: FormInstance) => {
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const handleFormChange = () => {
    const errors = form.getFieldError('newPassword');
    const matchError = form.getFieldError('retypePassword');
    const arePasswordsMatch = form.getFieldValue('retypePassword') === form.getFieldValue('newPassword');
    setPasswordErrors(errors);
    setIsDisabled(!arePasswordsMatch || form.getFieldValue('newPassword')?.length === 0 || errors?.length > 0);
  };

  const formValidationHelpStates = null;

  return { isDisabled, passwordErrors, formValidationHelpStates, handleFormChange };
}; 